import { Box, Typography } from "@mui/material"
import { useTranslation } from "../../../explorer/hooks/useTranslation";
import { useClasses } from "./SearchNoResults.style";

const SearchNoResults = () => {
    const { t } = useTranslation();
    const classes = useClasses();
    
    return (
        <Box display="flex" p={1} sx={classes.searchTextBox}>
            <Typography component="p">
                {t("common.searchbar.noresaults")}
            </Typography>
        </Box>
    )
}

export default SearchNoResults;